<a (click)="openModuleDetail()">
  <nz-space>
    <nz-space-item>
      <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
    </nz-space-item>
    <nz-space-item>
      <span>{{prefix}}</span><span>{{value}}</span>
    </nz-space-item>
  </nz-space>
</a>

<ng-template #ApprovaldrawerTemplate let-drawerRef="drawerRef">
  <form nz-form [formGroup]="approvalForm" (ngSubmit)="onApprovalSubmit()">
    <nz-divider nzText="Authorization Details"></nz-divider>
    <nz-form-item>
      <nz-form-label> User </nz-form-label>
      <nz-form-control>
        <input
          type="text"
          disabled
          nz-input
          value="{{ ApprovalMessage.Requester }}"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Remarks </nz-form-label>
      <nz-form-control>
        <input
          type="text"
          disabled
          nz-input
          value="{{ ApprovalMessage.Remarks }}"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Template </nz-form-label>
      <nz-form-control>
        <input
          type="text"
          disabled
          nz-input
          value="{{ ApprovalMessage.TemplateName }} <{{
            ApprovalMessage.TemplateRemark
          }}>"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Stage </nz-form-label>
      <nz-form-control>
        <input
          type="text"
          disabled
          nz-input
          value="{{ ApprovalMessage.StageName }}"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Document Number </nz-form-label>
      <nz-form-control>
        <nz-button-group>
          <a
            nz-button
            nzType="link"
            (click)="openDraftDocument(ApprovalMessage.DocEntry)"
            >{{ ApprovalMessage.DocNum }}</a
          >
        </nz-button-group>
      </nz-form-control>
    </nz-form-item>
    <nz-divider nzText="Answer"></nz-divider>
    <nz-form-item>
      <nz-form-label> Decision </nz-form-label>
      <nz-form-control>
        <nz-select formControlName="AppStatus">
          <nz-option nzValue="W" nzLabel="Pending"></nz-option>
          <nz-option nzValue="Y" nzLabel="Approve"></nz-option>
          <nz-option nzValue="N" nzLabel="Not Approved"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Remarks </nz-form-label>
      <nz-form-control>
        <input type="text" nz-input formControlName="AppRemark" />
      </nz-form-control>
    </nz-form-item>
    <button
      nz-button
      type="submit"
      nzType="primary"
      (click)="drawerRef.close()"
    >
      Update Decision
    </button>
    <button
      nz-button
      type="button"
      nzType="default"
      (click)="drawerRef.close()"
    >
      close
    </button>
  </form>
</ng-template>
